import { normalizeWidgetTheme, APIURL, cancelSelectEvent, changeSymbolForWidget, getCSSStyles, getSymbolDropdown, getTraderSMCardHTML, getEChartsTooltipTheme, getWidgetDataURI, apiGet, toggleWidgetTheme, updateSelectedSymbolInDropdown, isHeaderPinned, getHeaderPinStateClass, getHeaderPinButtonHTML, setupHeaderPin, getNoDataHTML, isEmptyWidgetData } from './../../helpers';
import { WidgetConfig, WidgetEvent, WidgetEventHandler, WidgetEventType } from './../../types';

export class TraderverseSpotVolumeChart {
    private container: HTMLElement;
    private config: WidgetConfig;
    private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
    private updateInterval: number | null = null;
    private selectedInterval: string = '1y';
    private displayMode: 'market_share' | 'total' = 'market_share';
    private shadowRoot: ShadowRoot;
    private currentData: any = null;
    private currentChart: any;
    private selectedLegends: string[] = [];
    private widgetResizeObserver: ResizeObserver | null = null;

    constructor(config: WidgetConfig) {
        this.config = { ...this.getDefaultConfig(), ...config };
        this.config.theme = normalizeWidgetTheme(this.config.theme);
        this.container = this.resolveContainer(config.container);

        if ((this.container as any).shadowRoot) {
            this.shadowRoot = (this.container as any).shadowRoot;
        } else {
            this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
        }
        this.init();

        this.widgetResizeObserver = new ResizeObserver(() => {
            this.updateDisplay();
        });
        setTimeout(() => {
            const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
            if (widget) this.widgetResizeObserver?.observe(widget);
        }, 0);
    }

    private fetchSymbols(): Array<{ value: string; label: string }> {
        return [
            { label: 'AAPL', value: 'AAPL' }, { label: 'MSFT', value: 'MSFT' },
            { label: 'GOOGL', value: 'GOOGL' }, { label: 'AMZN', value: 'AMZN' },
            { label: 'NVDA', value: 'NVDA' }, { label: 'META', value: 'META' },
            { label: 'TSLA', value: 'TSLA' }, { label: 'AVGO', value: 'AVGO' },
            { label: 'PEP', value: 'PEP' }, { label: 'COST', value: 'COST' }
        ];
    }

    private getDefaultConfig(): Partial<WidgetConfig> {
        const symbols = this.fetchSymbols();
        return {
      headerPinned: true,
            symbol: symbols[0].value,
            theme: 'default-dark',
            width: '100%',
            height: '400px',
            autosize: true
        };
    }

    private resolveContainer(container: string | HTMLElement): HTMLElement {
        if (typeof container === 'string') {
            const el = document.getElementById(container) || document.querySelector(container);
            if (!el) throw new Error(`Container not found: ${container}`);
            return el as HTMLElement;
        }
        return container;
    }

    private async init(): Promise<void> {
        if (!this.config.symbol) this.config.symbol = this.fetchSymbols()[0].value;
        this.createWidget();
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        if (widget) widget.classList.add('loading');
        await this.injectChartLibrary();
        this.attachStyles();
        this.setupEventListeners();
        await this.setupChart(this.config.symbol!);
        if (widget) widget.classList.remove('loading');
        this.emit('ready', {});
        cancelSelectEvent(this.shadowRoot);
        this.config.onReady?.();
    }

        private createWidget(): void {
            let themeClass = 'defaultDarkMode';
          let dataTheme = 'default-dark';
          
          if (this.config.theme === 'white') {
            themeClass = 'whiteMode';
            dataTheme = 'white';
          } else if (this.config.theme === 'black') {
            themeClass = 'blackMode';
            dataTheme = 'black';
          } else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}
                const widgetHtml = `
    <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width  };height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-theme="${dataTheme}">
                    <div class="headTop">
                        <h4 class="title crypto">${this.getTitleIconSvg()} CEX Spot Volume Chart</h4>
                        <div class="actionCol">${getHeaderPinButtonHTML(this.config)}
                            <i class="pi pi-ellipsis-v"></i>
                        </div>
                    </div>
                    <div class="inBody">
                        <div class="optionsRow">
                                <div class="item">
                                    <select class="dropdown-btn">
                                        <option value="total">Total</option>
                                        <option value="market_share">Market Share</option>
                                    </select>
                                </div>
                                <span></span>
                                <div class="item">
                                        <div class="legendsCollection" id="dynamic-legends"></div>
                                </div>
                                <div class="item">
                                    <select class="dropdown-btn">
                                        <option value="30d">30 days</option>
                                        <option value="1y">1 year</option>
                                    </select>
                                </div>
                        </div>
                        <div class="optionsRow" style="display:none;">
                                <div class="item tabsDv padHt value-tabs">
                                        <button class="value-tab" data-mode="total">Total</button>
                                        <button class="value-tab active" data-mode="market_share">Market Share</button>
                                </div>
                                <span></span>
                                <div class="item tabsDv padHt interval-tabs">
                                        <button class="tab" data-interval="30d">30 days</button>
                                        <button class="tab active" data-interval="1y">1 year</button>
                                </div>
                        </div>
                        <div class="chartDv" id="PriceCamprisonContainer"></div>
                    </div>
                </div>
        `;
                this.shadowRoot.innerHTML = widgetHtml;
                if (this.config.isSymbolSelectable && !this.config.hideSymbol) {
                        const dropdown = getSymbolDropdown((data: any) => this.onSelectChange(data), 'crypto');
                        const placeholder = this.shadowRoot.getElementById('symbol-dropdown-placeholder');
                        if (placeholder && dropdown) {
                                placeholder.replaceWith(dropdown);
                        }
                }
        }
    // Render legends dynamically based on series and colors
    private renderLegends(series: any[]): void {
        const legendsContainer = this.shadowRoot.getElementById('dynamic-legends');
        if (!legendsContainer) return;
        legendsContainer.innerHTML = '';
        series.forEach((s, i) => {
            const legend = document.createElement('span');
            legend.className = 'toggle-series';
            legend.setAttribute('data-series', s.name);
            // legend.setAttribute('title', s.name);
            legend.setAttribute('data-tooltip', s.name);
            legend.style.backgroundColor = s.areaStyle.color;
            legend.style.border = this.selectedLegends.includes(s.name) ? '2px solid #333' : 'none';
            // legend.style.cursor = 'pointer';
            // legend.style.width = '20px';
            // legend.style.height = '20px';
            // legend.style.display = 'inline-block';
            // legend.style.marginRight = '6px';
            legend.onclick = () => {
                if (this.selectedLegends.includes(s.name)) {
                    this.selectedLegends = this.selectedLegends.filter(l => l !== s.name);
                } else {
                    this.selectedLegends = [...this.selectedLegends, s.name];
                }
                this.updateDisplay();
            };
            legendsContainer.appendChild(legend);
        });
    }

    onSelectChange(stock: any) {
        this.changeSymbol(stock.symbol, stock);
    }

    private async attachStyles(): Promise<void> {
        try {
            const styleEl = await getCSSStyles();
            this.shadowRoot.appendChild(styleEl);
        } catch (err) {
            console.error('Failed to load CSS file:', err);
        }
    }

    private setupEventListeners(): void {
    setupHeaderPin(this.shadowRoot, this.config);
        const dropdown = this.shadowRoot.querySelector('.symbol-dropdown') as HTMLSelectElement;
        dropdown?.addEventListener('change', e => {
            const value = (e.target as HTMLSelectElement).value;
            this.changeSymbol(value);
        });
        if (dropdown && this.config.symbol) dropdown.value = this.config.symbol;
        const tabs = Array.from(this.shadowRoot.querySelectorAll('.interval-tabs .tab')) as HTMLButtonElement[];
        if (tabs && tabs.length) {
            tabs.forEach(tab => {
                const iv = tab.getAttribute('data-interval') || '';
                if (iv === this.selectedInterval) tab.classList.add('active');
                tab.addEventListener('click', () => {
                    const interval = tab.getAttribute('data-interval') || '1y';
                    this.selectedInterval = interval;
                    tabs.forEach(t => t.classList.toggle('active', t === tab));
                    this.setupChart(this.config.symbol, undefined, this.selectedInterval);
                });
            });
        }
        const valueTabs = Array.from(this.shadowRoot.querySelectorAll('.value-tabs .value-tab')) as HTMLButtonElement[];
        if (valueTabs && valueTabs.length) {
            valueTabs.forEach(tab => {
                const mode = tab.getAttribute('data-mode') || 'market_share';
                if (mode === this.displayMode) tab.classList.add('active');
                tab.addEventListener('click', () => {
                    this.displayMode = (tab.getAttribute('data-mode') as any) || 'market_share';
                    valueTabs.forEach(t => t.classList.toggle('active', t === tab));
                    this.updateDisplay();
                });
            });
        }
    }

    private async injectChartLibrary(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            if ((window as any).echarts) return resolve(true);
            if (this.shadowRoot.querySelector('script[data-chart-lib]')) {
                const script = this.shadowRoot.querySelector('script[data-chart-lib]') as HTMLScriptElement;
                script.onload = () => resolve(true);
            } else {
                const script = document.createElement('script');
                script.src = 'https://cdn.jsdelivr.net/npm/echarts@5/dist/echarts.min.js';
                script.async = true;
                script.setAttribute('data-chart-lib', 'true');
                this.shadowRoot.appendChild(script);
                script.onload = () => resolve(true);
            }
        });
    }

    private async setupChart(symbol?: string, stockInfo?: any, interval?: string): Promise<void> {
        try {
            const useInterval = interval ?? this.selectedInterval ?? '1y';
            const response = await apiGet({
                method: 'GET',
                url: `${APIURL}/v1/crypto/cex?interval=${useInterval}`,
                body: { interval: useInterval },
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) throw new Error("Failed to fetch data");
            this.currentData = await response.json();

            this.updateDisplay();
            this.emit('dataUpdate', this.currentData);
        } catch (err) {
            console.error("Error fetching chart data:", err);
        }
    }

    private updateDisplay(): void {
        const container = this.shadowRoot.querySelector('#PriceCamprisonContainer') as HTMLElement;
        if (!(window as any).echarts) {
            setTimeout(() => this.updateDisplay(), 100);
            return;
        }
        if (!this.currentData || isEmptyWidgetData(this.currentData.data)) {
            if (container) container.innerHTML = getNoDataHTML();
            return;
        }
        this.renderAnalystRating();
    }

    private renderAnalystRating(): void {
        const container = this.shadowRoot.querySelector('#PriceCamprisonContainer');
        if (!container) return;
            const hasData = this.currentData?.data && this.currentData.data.length > 0;

    if (hasData) {
        (container as HTMLElement).setAttribute('data-testing-id', 'spot-volume-chart');
    } else {
        (container as HTMLElement).removeAttribute('data-testing-id');
    }

        const html = `
        <div class="chart" id="marketRealtimeChart"></div>
    `;
        container.innerHTML = html;
        this.drawChart();
    }


    private drawChart(): void {
        const echarts = (window as any).echarts;
        const container = this.shadowRoot.querySelector('#marketRealtimeChart') as HTMLElement;
        if (!container || !this.currentData?.data) return;

        const chartData = this.currentData.data;
        const getVolume = (item: any) => {
            const v = item?.quote?.USD?.volume_24h ?? item?.volume_24h ?? 0;
            return Number(v) || 0;
        };
        const grouped: Record<string, { date: string; share: number; total: number }[]> = {};
        chartData.forEach((item: any) => {
            const date = new Date(item.timestamp).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            const exchange = item.exchange_name;
            const share = Number(item.market_share) || 0;
            const total = getVolume(item);
            if (!grouped[exchange]) grouped[exchange] = [];
            grouped[exchange].push({ date, share, total });
        });
        const allDates = [...new Set(chartData.map((x: any) =>
            new Date(x.timestamp).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
        ))].sort((a: any, b: any) => new Date(a).getTime() - new Date(b).getTime());
        const isBlack = this.config.theme === 'black';
        const tooltipBg = isBlack ? '#333' : '#fff';
        const tooltipTextColor = isBlack ? '#fff' : '#000';
        const legendTextColor = isBlack ? '#ccc' : '#333';
        const colorPalette = [
            '#fbc02d', '#ff9800', '#9e9e9e', '#2196f3', '#3f51b5', '#e91e63',
            '#4caf50', '#00bcd4', '#8bc34a', '#ff5722', '#795548', '#009688'
        ];
        let series = Object.keys(grouped).map((exchange, i) => ({
            name: exchange,
            type: 'line',
            stack: 'Total',
            smooth: true,
            showSymbol: false,
            lineStyle: { width: 0 },
            areaStyle: {
                opacity: 0.9,
                color: colorPalette[i % colorPalette.length],
            },
            emphasis: { focus: 'series' },
            data: allDates.map(date => {
                const point = grouped[exchange].find(x => x.date === date);
                if (!point) return 0;
                return this.displayMode === 'market_share' ? Number(point.share.toFixed(2)) : point.total;
            })
        }));
        // Filter series if legends are selected
        if (this.selectedLegends.length > 0) {
            series = series.filter(s => this.selectedLegends.includes(s.name));
        }
        // Render legends
        this.renderLegends(Object.keys(grouped).map((exchange, i) => ({
            name: exchange,
            areaStyle: { color: colorPalette[i % colorPalette.length] }
        })));
        const instance = echarts.getInstanceByDom(container);
        if (instance) echarts.dispose(instance);
        const formatValue = (val: any) => {
            const num = Number(val) || 0;
            if (this.displayMode === 'market_share') return `${num}%`;
            try {
                const nf = new Intl.NumberFormat('en-US', { notation: 'compact', compactDisplay: 'short', maximumFractionDigits: 1, style: 'currency', currency: 'USD' });
                return nf.format(num);
            } catch (e) {
                const nf = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
                return nf.format(num);
            }
        };
        const widgetBox = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        const textColor = getComputedStyle(widgetBox).getPropertyValue('--charts-text-color');
        const axisLineColor = getComputedStyle(widgetBox).getPropertyValue('--charts-axis-color');
        const splitLineColor = getComputedStyle(widgetBox).getPropertyValue('--charts-split-line-color');
        const fontSize = getComputedStyle(widgetBox).getPropertyValue('--font-size-sm');
        const option = {
            backgroundColor: 'transparent',
            tooltip: {
                trigger: 'axis',
                ...getEChartsTooltipTheme(widgetBox),
                formatter: (params: any) => {
                    const date = params[0]?.axisValue;
                    let html = `<b>${date}</b><br/>`;
                    params.forEach((p: any) => {
                        const value = p.value;
                        const displayVal = formatValue(value);
                        html += `<span style="display:inline-block;margin-right:5px;width:10px;height:10px;background:${p.color}"></span> ${p.seriesName}: ${displayVal}<br/>`;
                    });
                    return html;
                }
            },
            grid: { left: 0, right: 0, top: 10, bottom: 0, containLabel: true },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: allDates,
                axisLabel: { color: textColor, fontSize: fontSize,  },
                axisLine: { lineStyle: { color: axisLineColor  } },
            },
            yAxis: {
                type: 'value',
                min: 0,
                axisLabel: {
                    color: textColor, fontSize: fontSize,
                    formatter: (val: any) => formatValue(val)
                },
                splitLine: { lineStyle: { color: splitLineColor } },
            },
            series,
        };
        this.currentChart = echarts.init(container);
        this.currentChart.setOption(option);
    }


    private changeSymbol(stockId: string, stock: any = null): void {
        changeSymbolForWidget(this.shadowRoot, this.config, stock, stockId, (stockId: any, stockInfo: any) => this.setupChart(stockId, stockInfo, this.selectedInterval), (type: any, data: any) => this.emit(type, data));
    }

    public on(type: WidgetEventType, handler: WidgetEventHandler): void {
        if (!this.eventHandlers.has(type)) this.eventHandlers.set(type, []);
        this.eventHandlers.get(type)!.push(handler);
    }
    public off(type: WidgetEventType, handler: WidgetEventHandler): void {
        const list = this.eventHandlers.get(type);
        if (list) this.eventHandlers.set(type, list.filter(h => h !== handler));
    }
    public setSymbol(symbol: string): void {
        this.changeSymbol(symbol);
        const dropdown = this.shadowRoot.querySelector('.symbol-dropdown') as HTMLSelectElement;
        if (dropdown) dropdown.value = symbol;
    }
    public async getWidgetImage(): Promise<string> {
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        return await getWidgetDataURI(widget);
    }
  
    public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
      if (!this.shadowRoot) return;
    
      this.config.theme = toggleWidgetTheme(
        this.shadowRoot,
        theme
      ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';
    
      this.updateDisplay();
    }
    public destroy(): void {
        if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
        if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
        this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
    }
    private emit(type: WidgetEventType, data: any): void {
        const handlers = this.eventHandlers.get(type);
        if (handlers) { const evt: WidgetEvent = { type, data }; handlers.forEach(h => h(evt)); }
    }
  private getTitleIconSvg(): string {
    return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.15 20.3C12.3125 20.3 10 17.9875 10 15.15C10 12.3125 12.3125 10 15.15 10C17.9875 10 20.3 12.3125 20.3 15.15C20.3 17.9875 18 20.3 15.15 20.3ZM15.15 11.8625C13.3375 11.8625 11.875 13.3375 11.875 15.1375C11.875 16.9375 13.35 18.4125 15.15 18.4125C16.95 18.4125 18.425 16.9375 18.425 15.1375C18.425 13.3375 16.9625 11.8625 15.15 11.8625Z" fill="currentColor"/> <path d="M15 28.4375C7.5875 28.4375 1.5625 22.4125 1.5625 15C1.5625 7.5875 7.5875 1.5625 15 1.5625C22.4125 1.5625 28.4375 7.5875 28.4375 15C28.4375 22.4125 22.4125 28.4375 15 28.4375ZM15 3.4375C8.625 3.4375 3.4375 8.625 3.4375 15C3.4375 21.375 8.625 26.5625 15 26.5625C21.375 26.5625 26.5625 21.375 26.5625 15C26.5625 8.625 21.375 3.4375 15 3.4375Z" fill="currentColor"/> <path d="M15.0625 22C14.5158 22 14.0625 21.5192 14.0625 20.9394V9.06061C14.0625 8.48081 14.5158 8 15.0625 8C15.6092 8 16.0625 8.48081 16.0625 9.06061V20.9394C16.0625 21.5192 15.6092 22 15.0625 22Z" fill="currentColor"/> </svg>`;
  }

}

declare global { interface Window { TraderverseSpotVolumeChart: typeof TraderverseSpotVolumeChart; } }
if (typeof window !== 'undefined') { window.TraderverseSpotVolumeChart = TraderverseSpotVolumeChart; }